<template>
  <main>
    <!-- hero -->
    <div class="hero-alt">
      <div class="overlay">
        <div class="hero-title">Need accounting advice?</div>
        <div class="hero-subtitle">Free meetings all year with Slater</div>
      </div>
    </div>
    <!-- hero -->

    <!-- first section -->
    <section class="section-item">
      <div class="section-text">
        <div class="section-heading">We take care of the boring stuff</div>
        <div class="section-subheading">
          Your accounts and finalcials treated with care. So relax!
        </div>

        <div class="points">
          <div class="point">
            <img src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg" />
            <div>End of year accounts</div>
          </div>

          <div class="point">
            <img src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg" />
            <div>GST returns</div>
          </div>

          <div class="point">
            <img src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg" />
            <div>Advice all year round</div>
          </div>
        </div>
      </div>

      <div class="section-image">
        <img src="https://api.slater.co.nz/v/2f9a8bcc-b51f-4a18-be2f-3626fee11460.svg" />
      </div>
    </section>
    <!-- first section -->

    <!-- second section -->
    <section class="section-item">
      <div class="section-image-mid">
        <img src="https://api.slater.co.nz/v/22e4fb07-e406-4fdd-8fb6-425b89c07ec4.svg" />
      </div>

      <div class="section-text-mid">
        <div class="section-heading">Accounting in the cloud</div>
        <div class="section-subheading">
          Slater was one of the first xero only accounting firms in New Zealand
        </div>

        <div class="points">
          <div class="point">
            <img src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg" />
            <div>In house Xero specialists</div>
          </div>

          <div class="point">
            <img src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg" />
            <div>Free training</div>
          </div>

          <div class="point">
            <img src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg" />
            <div>Make your switch to Xero smooth as</div>
          </div>
        </div>
      </div>
    </section>
    <!-- second section -->

    <!-- third section -->
    <!-- <section class="section-item">
      <div class="section-text">
        <div class="section-heading">Registered Professionals</div>
        <div class="section-subheading">
          Member of a globally connected organisation of the profession's finest
        </div>

        <div class="points">
          <div class="point">
            <img src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg" />
            <div>Over 25 years accredited</div>
          </div>

          <div class="point">
            <img src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg" />
            <div>Honest to a tee</div>
          </div>

          <div class="point">
            <img src="https://api.slater.co.nz/v/29f05c7a-ef10-4a8d-9edf-4bf1be9d9c8a.svg" />
            <div>Uphold the highest ethical, professional and technical standards</div>
          </div>
        </div>
      </div>

      <div class="section-image">
        <img src="https://api.slater.co.nz/v/be0f27a5-96bd-4998-a01a-d32ffdb10c74.svg" />
      </div>
    </section> -->
    <!-- third section -->

    <!-- cta -->
    <section class="cta">
      <div class="cta-title">Experience the Slater difference</div>
      <div class="cta-subtitle">Too busy to come to us? we can come to you!</div>

      <a href="/contact" class="cta-button">
        <div>Lets talk</div>
      </a>
    </section>
    <!-- cta -->
  </main>
</template>

<script setup>
document.title = 'Slater Hamilton Accountants & Business Development';
</script>

<style scoped>
.hero-alt {
  margin-top: 50px;
  height: 730px;
  width: 100%;
  position: relative;
  background-image: url('https://api.slater.co.nz/v/6d822032-4563-49e0-8393-afce5caa2176.jpg');
  background-size: cover;
  background-position: 0 -200px;
}

.overlay {
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hero-title {
  color: #fff;
  font-size: 65px;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;
}

.hero-subtitle {
  color: #fff;
  font-size: 27px;
  font-weight: 500;
  text-align: center;
}

.section-item {
  margin-top: 200px;
  display: flex;
}

.section-text,
.section-text-mid {
  width: 30vw;
  display: flex;
  flex-direction: column;
}

.section-text {
  margin-left: 10vw;
}

.section-text-mid {
  margin-left: 2vw;
  order: 2;
}

.section-image,
.section-image-mid {
  width: 30vw;
  display: flex;
  align-items: center;
}

.section-image {
  margin-left: 10vw;
}

.section-image-mid {
  margin-left: 10vw;
  order: 1;
}

.section-heading {
  font-size: 38px;
  font-weight: 600;
  color: #213b55;
}

.section-subheading {
  color: #213b55;
  margin: 30px 0;
  font-size: 21px;
}

.points {
  display: flex;
  flex-direction: column;
}

.point {
  display: flex;
  margin-bottom: 20px;
  color: #213b55;
  font-size: 18px;
}

.point img {
  width: 20px;
  height: 20px;
}

.point div {
  margin-left: 20px;
  text-align: left;
}

.section-image img {
  width: 450px;
  height: 100%;
}

.section-image-mid img {
  width: 300px;
  height: 100%;
}

.section-item:first-of-type .section-image img {
  width: 200px;
}

.cta {
  margin: 200px 2vw;
  display: flex;
  flex-direction: column;
  background-color: #6fefc1;
  align-items: center;
  justify-content: center;
}

.cta-title {
  font-size: 51px;
  font-weight: 600;
  color: #213b55;
  margin-top: 50px;
  text-align: center;
  padding: 10px;
}

.cta-subtitle {
  font-size: 27px;
  color: #213b55;
  margin-top: 10px;
}

.cta-button {
  font-weight: 500;
  margin: 50px 0;
  background-color: #213b55;
  color: #fff;
  padding: 5px 20px;
  font-size: 20px;
  border-radius: 4px;
  text-decoration: none;
}

@media (max-width: 768px) {
  .hero-alt {
    height: 500px;
    margin-top: 0;
    background-position: center;
  }

  .section-item {
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    text-align: center;
  }

  .section-text,
  .section-text-mid,
  .section-image,
  .section-image-mid {
    width: 100%;
    margin-left: 0;
    justify-content: center;
    padding: 15px;
  }

  .points {
    margin-left: 13vw;
  }
}

@media (max-width: 480px) {
  .hero-alt {
    background-image: none;
    background-color: #bbf3fd;
  }

  .overlay {
    background-color: unset;
  }

  .hero-title,
  .hero-subtitle {
    color: #213b55;
  }
}
</style>
